// The status dots of the « Règles de zonage » card. One list of keys with the backend
// (backend/app/champs/urbanisme/vocabulaire/rule_dots.py); the rule-dots guard holds them equal.
export const RULE_DOTS = Object.freeze({
  PERMITTED_USES: 'permitted_uses',
  MAX_STOREYS: 'max_storeys',
  LOT_COVERAGE: 'lot_coverage',
  FLOOR_AREA_RATIO: 'floor_area_ratio',
  SETBACKS: 'setbacks',
});

// How a norme was read on the secteur's fiche (ADR-002); a dot without a state was not read there.
export const NORME_STATES = Object.freeze({
  prescribed: { label: 'Confirmé sur la fiche officielle', color: 'bg-green-500' },
  not_prescribed: { label: 'Non prescrit par la fiche officielle', color: 'bg-slate-500' },
  unverifiable: { label: 'Non vérifiable sur la fiche officielle', color: 'bg-orange-500' },
});
export const NOT_READ = Object.freeze({ label: 'Non lu sur la fiche officielle', color: 'bg-gray-300' });
